import Link from "next/link"

export function Footer() {
  return (
    <footer className="border-t bg-muted/50 mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="font-bold text-lg mb-4">Prompt Market</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">최고의 AI 프롬프트를 사고 파는 마켓플레이스</p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">마켓</h4>
            <ul className="space-y-2">
              <li>
                <Link href="/categories" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  카테고리
                </Link>
              </li>
              <li>
                <Link href="/new" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  새로운 프롬프트
                </Link>
              </li>
              <li>
                <Link href="/popular" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  인기 프롬프트
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">크리에이터</h4>
            <ul className="space-y-2">
              <li>
                <Link href="/sell" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  프롬프트 판매하기
                </Link>
              </li>
              <li>
                <Link href="/creators" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  크리에이터 소개
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">고객지원</h4>
            <ul className="space-y-2">
              <li>
                <Link href="/help" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  도움말
                </Link>
              </li>
              <li>
                <Link href="/contact" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  문의하기
                </Link>
              </li>
              <li>
                <Link href="/terms" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  이용약관
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t text-center text-sm text-muted-foreground">
          <p>© 2026 Prompt Market. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}
